module.exports = __webpack_public_path__ + "static/bro1-7c56a2dc1d06f907954c1b7d0915c94c.jpg";